module.exports = __webpack_public_path__ + "static/img/page_19.ee2577c6.png";